
import { createStore, applyMiddleware, compose } from 'redux';

import reducer from './reducer';
import saga from './saga';
import middlewares from './middlewares';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = () => {
  const [sagaMiddleware] = middlewares;
  const store = createStore(
    reducer,
    composeEnhancers(applyMiddleware(...middlewares)),
  );
  sagaMiddleware.run(saga);
  return { store };
};

export default configureStore;
